export const toDocuments = documents => {
  return documents.reduce((acc, document) => {
    const { folder } = document
    if (!acc[folder.id]) {
      acc[folder.id] = []
    }
    acc[folder.id].push(document)
    return acc
  }, {})
}

export const toFolders = folders => folders.map(f => ({ value: f.id, label: f.name }))
